import service from './service';

export default {
  postResumeRecommend(data) {
    return service.get(`/api/v1/company/resume/recommend?pageIndex=${data}`);
  },
  getCompany() {
    return service.get('/api/v1/company/index');
  },
  // 收藏简历
  collectResume(body) {
    return service.post('/api/v1/company/resume/collect', body);
  },
  // 下载简历
  downloadResume(id, data, params) {
    let str = ''
    if (data) {
      str = '?info_id=' + data
    }
    return service.get(`/api/v1/resume/${id}/download${str}`, { params });
  },
  // 解绑微信
  unionWechat() {
    return service.post('/api/v1/user/wechat-unbind');
  },
  // 获取企业详情
  getCompanyList(id) {
    return service.get(`/api/v1/companies/${id}`);
  },
  // 获取再招职位
  getNowJobs(id) {
    return service.get(`/api/v1/companies/${id}/jobs`);
  },
  // 获取企业分享截图
  getScreenshot(data) {
    return service.post('/api/v1/file/screenshot-by-url', data);
  },
  // 自主兑换短信
  exchangeSMS(data) {
    return service.post(`/api/v1/company/exchange-sms`, data);
  }
};



// WEBPACK FOOTER //
// ./src/api/enterprise-center.js